import { useState, useEffect, Fragment } from 'react';
// import axios from 'axios';

import * as bucketUtils from '../../../utils/bucket/bucket-util';

import { useStore } from '../../../hook-store/store';
import { BACKEND_URL } from '../../../App';

function UpdateBucketCorsData(props) {

  const [store, dispatch] = useStore();
  const { 
    allBucketObjects,
  } = store.bucketObjectStore;
  const { isAuth } = store.uiStore;

  useEffect(() => {
    if (isAuth && allBucketObjects.length > 0) {
      updateBucketCorsDataHandler(
        BACKEND_URL,
        localStorage.getItem('token'),
      );
    }
  },[isAuth, allBucketObjects.length]);

  
  const updateBucketCorsDataHandler = async (url, token) => {
    try {
        const result = await fetch(url + `/bucket-setting/update-bucket-cors-data`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          // body: JSON.stringify({}),
        });

        const resData = await result.json();
        console.log(result, resData);

        if (result.ok) {
          return resData;
        } else {
          throw new Error('error occured');
        }
    } catch(err) {
      console.log(err);
      throw err;
    }
  };






  return (
    <Fragment>
    </Fragment>
  );
}

export default UpdateBucketCorsData;
